module.exports = __webpack_public_path__ + "static/media/facebookIcon.971a9fe1.svg";